import { 
    ADD_ACCOUNT,
    ADD_ALERT,
    FETCH_ALL_ACCOUNTS,
    UPDATE_ACCOUNT_INFO,
    ACCOUNT_DROPDOWN
} from './types';
import shortId from "shortid";
import sleektrading from "../apis/sleektrading"

export const addAccount = (values) => dispatch => {
    sleektrading.post('/accounts/create', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: ADD_ACCOUNT,
                    payload: response.data.data
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const fetchAllAccounts= () => async dispatch => {
    const {data} = await sleektrading.post(`/accounts/index`);
    
    if(data.code == 201){
        dispatch({
            type: FETCH_ALL_ACCOUNTS,
            payload: data.data.data
        });
    }
}

export const updateAccountInfo = (values) => dispatch => {
    sleektrading.post('/accounts/edit', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: UPDATE_ACCOUNT_INFO,
                    payload: response.data.data
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const fetchAccountsDropdown= () => async dispatch => {
    const {data} = await sleektrading.post(`/accounts/dropdown`);
    
    if(data.code == 201){
        dispatch({
            type: ACCOUNT_DROPDOWN,
            payload: data.data
        });
    }
} 


